import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

const SIGN_OUT_TITLE = 'profile.signOut';

@Component({
  selector: 'makaw-sign-out-modal',
  templateUrl: './sign-out-modal.component.html',
})
export class SignOutModalComponent {
  public signOut = SIGN_OUT_TITLE;
  constructor(
    public dialogRef: MatDialogRef<SignOutModalComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  doAction() {
    this.dialogRef.close({ event: 'Exit', data: this.data });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }
}
